export default __webpack_public_path__ + "static/media/1.2d66df3c.jpg";